import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// The welcome screen is now merged into the Sign In / Create Account tabs.
// Keep this route so existing links still work, preserving the `next` redirect.
export default function Splash() {
  const location = useLocation();
  const next = new URLSearchParams(location.search).get('next') || '/Order';
  return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
}